import { Box } from "@chakra-ui/react";
import Table from "../../../components/Table";
import { DstSchema, SrcSchema } from "../../../api/types";
import { typedSxMap } from "../../../utils/typedSxMap";
import { breakpoints } from "./utils/breakpoints";
import { overviewTable } from "./utils/overviewTable";


const styles = typedSxMap({
  tableWrapper: {
    display: "flex",
    overflowY: "auto",
    padding: "1px",
    marginRight: "-20px",
    paddingRight: "21px",
    maxHeight: "calc(100vh - 218px)",
    [breakpoints.md]: {
      maxHeight: "calc(100vh - 171px)",
    },
    height: "auto",
    "[role='rowgroup']": {
      overflowX: "hidden",
      "&:first-of-type": {
        minHeight: "44px",
      },
    },
  },
});

type OverviewTableProps = {
  dstSchema?: DstSchema;
  srcSchema?: SrcSchema;
};

export default function OverviewTable({ dstSchema, srcSchema }: OverviewTableProps) {
  const tableData = overviewTable(dstSchema || ([] as DstSchema), srcSchema || ([] as SrcSchema));

  return (
    <>
      {dstSchema && (
        <Box sx={{ ...styles.tableWrapper }}>
          <Table data={tableData as any} columnWidths={["2%", "30%", "20%", "10%", "39%"]} getRowStyles={() => ({})} />
        </Box>
      )}
    </>
  );
}
